<template>
  <div id="cadastro" @keydown.esc="fecharModal">
    <section class="modal-equipe" role="dialog" aria-modal="true" aria-labelledby="titulo-equipe">
      <header class="modal-topo">
        <div class="modal-titulo">
          <span class="modal-label">Gerenciamento</span>

          <p v-if="tituloAtividade" class="titulo-atividade">
            {{ tituloAtividade }}
          </p>
        </div>

        <button type="button" class="btn-fechar-modal" aria-label="Fechar gerenciamento da equipe" @click="fecharModal">
          ×
        </button>
      </header>

      <div class="modal-conteudo">
        <section class="painel-equipe painel-disponiveis">
          <div class="painel-cabecalho">
            <div>
              <h5>Integrantes disponíveis</h5>

            </div>

            <span class="contador">
              {{ membrosLivresFiltrados.length }}
            </span>
          </div>

          <label class="campo-busca">
            <i class="fa-solid fa-magnifying-glass" aria-hidden="true"></i>
            <input v-model="buscaMembrosLivres" type="search" placeholder="Buscar por nome ou e-mail..."
              aria-label="Buscar integrantes disponíveis" />
          </label>

          <div v-if="carregando" class="estado-lista" role="status">
            <i class="fa-solid fa-spinner fa-spin" aria-hidden="true"></i>
            <span>Carregando integrantes...</span>
          </div>

          <div v-else-if="membrosLivresFiltrados.length === 0" class="estado-lista">
            <i class="fa-solid fa-users" aria-hidden="true"></i>
            <p>
              {{ buscaMembrosLivres
                ? "Nenhum integrante encontrado para essa busca."
                : "Todos os integrantes do time já estão alocados."
              }}
            </p>
          </div>

          <div v-else class="lista-membros">
            <label v-for="membro in membrosLivresPaginados" :key="membro.id" class="membro-livre"
              :class="{ 'membro-selecionado': verificarGrupo(membro) }">
              <input type="checkbox" :checked="verificarGrupo(membro)" @change="toggleMembro(membro)" />

              <span class="avatar-membro" aria-hidden="true">
                {{ (membro.nome || "?").trim().charAt(0).toUpperCase() }}
              </span>

              <span class="dados-membro">
                <strong>{{ membro.nome || "Nome não informado" }}</strong>
                <small>{{ membro.email || "E-mail não informado" }}</small>
              </span>

              <i v-if="verificarGrupo(membro)" class="fa-solid fa-check icone-selecionado" aria-hidden="true"></i>
            </label>
          </div>

          <footer v-if="totalPaginasLivres > 1" class="paginacao-lista">
            <button type="button" :disabled="paginaMembrosLivres === 1"
              aria-label="Página anterior dos integrantes disponíveis" @click="paginaMembrosLivres--">
              <i class="fa-solid fa-chevron-left" aria-hidden="true"></i>
            </button>

            <span>
              {{ paginaMembrosLivres }} / {{ totalPaginasLivres }}
            </span>

            <button type="button" :disabled="paginaMembrosLivres >= totalPaginasLivres"
              aria-label="Próxima página dos integrantes disponíveis" @click="paginaMembrosLivres++">
              <i class="fa-solid fa-chevron-right" aria-hidden="true"></i>
            </button>
          </footer>
        </section>

        <div class="divisor-vertical" aria-hidden="true"></div>

        <section class="painel-equipe painel-alocados">
          <div class="painel-cabecalho">
            <div>
              <h5>Equipe atual</h5>
            </div>

            <span class="contador contador-equipe">
              {{ grupoAtividade.length }}
            </span>
          </div>

          <label class="campo-busca">
            <i class="fa-solid fa-magnifying-glass" aria-hidden="true"></i>
            <input v-model="buscaMembrosAlocados" type="search" placeholder="Buscar na equipe atual..."
              aria-label="Buscar integrantes da equipe atual" />
          </label>

          <div class="acoes-equipe">
            <span class="legenda-equipe">
              <i class="fa-solid fa-crown" aria-hidden="true"></i>
              Líderes podem ser identificados pelo selo.
            </span>

            <button v-if="grupoIdAtividade != null" type="button" class="btn-excluir-grupo"
              @click="excluirGrupoDeAtividade">
              <i class="fa-regular fa-trash-can" aria-hidden="true"></i>
              Excluir equipe
            </button>
          </div>

          <div v-if="grupoAtividadeFiltrado.length === 0" class="estado-lista">
            <i class="fa-solid fa-user-group" aria-hidden="true"></i>
            <p>
              {{ grupoAtividade.length
                ? "Nenhum integrante corresponde à busca."
                : "Nenhum integrante na equipe ainda."
              }}
            </p>
          </div>

          <div v-else class="lista-membros lista-alocados">
            <article v-for="item in membrosEquipePaginados" :key="item.membro.email || item.membro.id || item.index"
              class="membro-alocado">
              <span class="avatar-membro">
                {{ (item.membro.nome || "?").trim().charAt(0).toUpperCase() }}
              </span>

              <div class="dados-membro">
                <strong>
                  {{ formatarEnum(formatarNomeUsuario(item.membro.nome)) }}
                </strong>

                <span class="papel-membro" :class="{ 'papel-lider': verificarLidereanca(item.index) }">
                  <i v-if="verificarLidereanca(item.index)" class="fa-solid fa-crown" aria-hidden="true"></i>
                  {{ verificarLidereanca(item.index) ? "Líder" : "Participante" }}
                </span>
              </div>

              <div class="acoes-membro">
                <button type="button" class="switch-track" role="switch" :class="{
                  'switch-track-ativo': verificarLidereanca(item.index)
                }" :aria-checked="verificarLidereanca(item.index)" :aria-label="`Líder: ${item.membro.nome}`"
                  :disabled="alterandoIndex !== null ||
                    (verificarLidereanca(item.index) &&
                      verificarSeEhCoordenador(item.membro))
                    " :title="verificarLidereanca(item.index) &&
                      verificarSeEhCoordenador(item.membro)
                      ? 'Coordenadores devem permanecer como líderes'
                      : verificarLidereanca(item.index)
                        ? 'Remover função de liderança'
                        : 'Promover à liderança'
                      " @click="alterarFuncao(item.index)">
                  <span class="switch-thumb"></span>
                </button>

                <button type="button" class="btn-remover" :disabled="alterandoIndex !== null"
                  :aria-label="`Remover ${item.membro.nome} da equipe`" title="Remover integrante"
                  @click="removerMembroGrupo(item.index)">
                  <i class="fa-solid fa-user-minus" aria-hidden="true"></i>
                  <span>Remover</span>
                </button>
              </div>
            </article>
          </div>

          <footer v-if="totalPaginasEquipe > 1" class="paginacao-lista">
            <button type="button" :disabled="paginaEquipeAtual === 1" aria-label="Página anterior da equipe"
              @click="paginaEquipeAtual--">
              <i class="fa-solid fa-chevron-left" aria-hidden="true"></i>
            </button>

            <span>
              {{ paginaEquipeAtual }} / {{ totalPaginasEquipe }}
            </span>

            <button type="button" :disabled="paginaEquipeAtual >= totalPaginasEquipe"
              aria-label="Próxima página da equipe" @click="paginaEquipeAtual++">
              <i class="fa-solid fa-chevron-right" aria-hidden="true"></i>
            </button>
          </footer>
        </section>
      </div>

      <footer class="modal-rodape">
        <p class="dica-rodape">
          <i class="fa-solid fa-circle-info" aria-hidden="true"></i>
          As alterações de liderança e remoção são realizadas individualmente.
        </p>

        <div class="botoes-rodape">

          <button id="btn-salvar" type="button" :disabled="!novosMembros.length" @click="adicionarMembros">
            <i class="fa-solid fa-user-plus" aria-hidden="true"></i>
            Adicionar selecionados
            <span v-if="novosMembros.length">
              ({{ novosMembros.length }})
            </span>
          </button>
        </div>
      </footer>
    </section>

    <Transition name="aviso-fade">
      <div v-if="aviso.visivel" class="aviso-overlay" @click.self="fecharAviso">
        <div class="aviso-box" role="alertdialog" aria-modal="true" aria-labelledby="titulo-aviso">
          <div class="modal-header">
            <span class="modal-label">

              {{ aviso.tipo === "sucesso" ? "Aviso" : "Confirmação" }}
            </span>

            <button type="button" class="btn-fechar-modal" aria-label="Fechar aviso" @click="fecharAviso">
              ×
            </button>
          </div>

          <div class="aviso-corpo">
            <div class="aviso-icone" :class="aviso.tipo">
              <span v-if="aviso.tipo === 'sucesso'">✓</span>
              <span v-else>?</span>
            </div>

            <p class="aviso-mensagem">{{ aviso.mensagem }}</p>

            <div class="aviso-botoes">
              <button v-if="aviso.tipo !== 'sucesso'" type="button" class="aviso-btn aviso-btn-sim"
                @click="confirmarAviso">
                Sim, confirmar
              </button>

              <button type="button" class="aviso-btn aviso-btn-cancelar" @click="fecharAviso">
                {{ aviso.tipo === "sucesso" ? "OK" : "Cancelar" }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </Transition>
  </div>
</template>


<script setup>
import {
  ref,
  computed,
  watch,
  onMounted,
  onBeforeUnmount,
} from "vue";
import atividadeService from "@/service/atividadeService";
import acaoService from "@/service/acaoService";
import { formatarEnum, formatarNomeUsuario } from "@/utils/FormatarEntradas";
import { useRoute } from "vue-router";
import grupoService from "@/service/grupoService";

const props = defineProps({
  acaoId: { type: String },
  atividadeId: { type: String },
});

const emit = defineEmits(["fecharGestaoDeEquipe"]);

const membrosLivres = ref([]);
const grupoAtividade = ref([]);
const grupoCadastrado = ref(false);
const novosMembros = ref([]);
const timeAcao = ref([]);
const carregando = ref(true);
const route = useRoute();
const grupoIdAtividade = ref(null);
const tituloAtividade = ref("");
const alterandoIndex = ref(null);
const aviso = ref({
  visivel: false,
  mensagem: "",
  tipo: "confirmacao",
  resolve: null,
});
const buscaMembrosLivres = ref("");
const buscaMembrosAlocados = ref("");

const paginaMembrosLivres = ref(1);
const paginaEquipeAtual = ref(1);

const ITENS_POR_PAGINA = 3;

const membrosLivresFiltrados = computed(() => {
  const busca = buscaMembrosLivres.value
    .trim()
    .toLocaleLowerCase("pt-BR");

  if (!busca) {
    return membrosLivres.value;
  }

  return membrosLivres.value.filter((membro) => {
    const nome = (membro.nome || "").toLocaleLowerCase("pt-BR");
    const email = (membro.email || "").toLocaleLowerCase("pt-BR");

    return nome.includes(busca) || email.includes(busca);
  });
});

const totalPaginasLivres = computed(() =>
  Math.ceil(membrosLivresFiltrados.value.length / ITENS_POR_PAGINA)
);

const membrosLivresPaginados = computed(() => {
  const inicio = (paginaMembrosLivres.value - 1) * ITENS_POR_PAGINA;

  return membrosLivresFiltrados.value.slice(
    inicio,
    inicio + ITENS_POR_PAGINA
  );
});

const grupoAtividadeFiltrado = computed(() => {
  const busca = buscaMembrosAlocados.value
    .trim()
    .toLocaleLowerCase("pt-BR");

  return grupoAtividade.value
    .map((membro, index) => ({ membro, index }))
    .filter(({ membro }) => {
      if (!busca) return true;

      const nome = (membro.nome || "").toLocaleLowerCase("pt-BR");
      const email = (membro.email || "").toLocaleLowerCase("pt-BR");

      return nome.includes(busca) || email.includes(busca);
    });
});

const totalPaginasEquipe = computed(() =>
  Math.ceil(grupoAtividadeFiltrado.value.length / ITENS_POR_PAGINA)
);

const membrosEquipePaginados = computed(() => {
  const inicio = (paginaEquipeAtual.value - 1) * ITENS_POR_PAGINA;

  return grupoAtividadeFiltrado.value.slice(
    inicio,
    inicio + ITENS_POR_PAGINA
  );
});

watch(buscaMembrosLivres, () => {
  paginaMembrosLivres.value = 1;
});

watch(buscaMembrosAlocados, () => {
  paginaEquipeAtual.value = 1;
});

watch(totalPaginasLivres, (total) => {
  if (paginaMembrosLivres.value > total) {
    paginaMembrosLivres.value = Math.max(1, total);
  }
});

watch(totalPaginasEquipe, (total) => {
  if (paginaEquipeAtual.value > total) {
    paginaEquipeAtual.value = Math.max(1, total);
  }
});

function fecharModal() {
  emit("fecharGestaoDeEquipe");
}

function mostrarConfirmacao(mensagem) {
  return new Promise((resolve) => {
    aviso.value = { visivel: true, mensagem, tipo: "confirmacao", resolve };
  });
}

function mostrarSucesso(mensagem) {
  return new Promise((resolve) => {
    aviso.value = { visivel: true, mensagem, tipo: "sucesso", resolve };
  });
}

function confirmarAviso() {
  const res = aviso.value.resolve;
  aviso.value.visivel = false;
  if (res) res(true);
}

function fecharAviso() {
  const res = aviso.value.resolve;
  aviso.value.visivel = false;
  if (res) res(false);
}

function verificarGrupo(membro) {
  if (!novosMembros.value) return false;
  return novosMembros.value.some((m) => m.id === membro.id);
}

function verificarLidereanca(index) {
  if (!grupoAtividade.value || !grupoAtividade.value[index]) return false;
  const membro = grupoAtividade.value[index];
  return membro.regras && Array.isArray(membro.regras)
    ? membro.regras.some(
      (regra) => regra.nome === "LIDER" || regra.nome === "COORDENADOR"
    )
    : false;
}

function verificarSeEhCoordenador(membro) {
  if (!membro || !membro.regras || !Array.isArray(membro.regras)) {
    return false;
  }
  return membro.regras.some((regra) => regra.nome === "COORDENADOR" || (regra.nome && regra.nome.toUpperCase().includes("COORDENADOR")));
}

function toggleMembro(membro) {
  if (verificarGrupo(membro)) {
    removerMembro(membro);
  } else {
    adicionarMembro(membro);
  }
}

function adicionarMembro(membro) {
  if (!novosMembros.value) novosMembros.value = [];
  if (!verificarGrupo(membro)) {
    novosMembros.value.push(membro);
  }
}

function removerMembro(membro) {
  if (!novosMembros.value) return;
  novosMembros.value = novosMembros.value.filter((m) => m.id !== membro.id);
}

async function removerMembroGrupo(index) {
  if (!grupoAtividade.value || !grupoAtividade.value[index]) return;
  const membro = grupoAtividade.value[index];
  const confirmacao = await mostrarConfirmacao(
    `Tem certeza de que deseja remover\n<${membro.nome}> da equipe?`
  );
  if (!confirmacao) return;
  const remover = [{ emailMembros: membro.email }];
  try {
    await atividadeService.removerMembroGrupo(props.atividadeId, remover);
    await carregarGrupo();
    await getEquipeAcao();
  } catch (error) {
    console.error("Erro ao remover membro:", error);
  }
}

async function carregarTituloAtividade() {
  try {
    const response = await atividadeService.getAtividadeId(props.atividadeId);
    if (response?.status === 200) {
      tituloAtividade.value =
        response.data?.titulo ?? response.data?.nome ?? "";
    } else {
      tituloAtividade.value = "";
    }
  } catch (error) {
    console.error("Erro ao carregar título da atividade:", error);
    tituloAtividade.value = "";
  }
}

async function excluirGrupoDeAtividade() {
  if (!grupoCadastrado.value) return;
  const confirmacao = await mostrarConfirmacao(
    `Tem certeza de que deseja excluir\na equipe formada?`
  );
  if (!confirmacao) return;
  try {
    await grupoService.deletGrupoAtividade(grupoIdAtividade.value);
    grupoAtividade.value = [];
    grupoCadastrado.value = false;
    grupoIdAtividade.value = null;
    await getEquipeAcao();
  } catch (error) {
    console.error("Erro ao excluir grupo:", error);
  }
}

async function getEquipeAcao() {
  try {
    const acaoId = props.acaoId || route.params.id;
    if (!acaoId) return;
    const equipeAcaoData = await acaoService.getMembrosTime(acaoId);
    timeAcao.value = equipeAcaoData;

    if (
      grupoCadastrado.value &&
      grupoAtividade.value &&
      grupoAtividade.value.length > 0
    ) {
      membrosLivres.value = equipeAcaoData.filter((membroAcao) => {
        return !grupoAtividade.value.some(
          (membroGrupo) => membroGrupo.email === membroAcao.email
        );
      });
    } else {
      membrosLivres.value = [...equipeAcaoData];
    }

    membrosLivres.value.sort((a, b) =>
      (a.nome?.toLowerCase() || "").localeCompare(b.nome?.toLowerCase() || "")
    );
  } catch (error) {
    console.error("Erro ao carregar equipe da ação:", error);
    membrosLivres.value = [];
  }
}

async function adicionarMembros() {
  if (!novosMembros.value || novosMembros.value.length === 0) return;
  const membrosValidos = novosMembros.value.filter(
    (membro) => membro && membro.email && membro.id
  );
  if (membrosValidos.length === 0) return;

  const confirmacao = await mostrarConfirmacao(
    `Tem certeza que deseja adicionar\n<${membrosValidos.length}> membro(s) à equipe?`
  );
  if (!confirmacao) return;

  const payload = membrosValidos
    .map((membro) => ({
      emailMembros: membro.email,
      funcao: verificarSeEhCoordenador(membro) ? "LIDER" : "PARTICIPANTE",
    }))
    .filter((item) => item.emailMembros != null);

  try {
    if (grupoCadastrado.value) {
      await atividadeService.adicionarMembroGrupo(props.atividadeId, payload);
    } else {
      await atividadeService.cadastrarGrupoAtividade(
        props.atividadeId,
        payload
      );
    }
    await carregarGrupo();
    await getEquipeAcao();
    novosMembros.value = [];
  } catch (error) {
    console.error("Erro ao adicionar membros:", error);
  }
}

async function carregarGrupo() {
  try {
    const response = await atividadeService.getGrupoAtividade(
      props.atividadeId
    );
    grupoIdAtividade.value = response.grupoId;

    let membros = [];

    if (response.Membros) {
      membros = response.Membros;

      // Garantir que coordenadores apareçam como líderes
      membros = membros.map((membro) => {
        const ehCoordenador = verificarSeEhCoordenador(membro);
        if (
          ehCoordenador &&
          (!membro.regras || !membro.regras.some((r) => r.nome === "LIDER"))
        ) {
          // Se for coordenador mas não tem regra LIDER, adicionar
          if (!membro.regras) membro.regras = [];
          membro.regras.push({ nome: "LIDER" });
        }
        return membro;
      });
    }

    if (membros.length > 0) {
      grupoAtividade.value = membros;
      grupoCadastrado.value = true;
    } else {
      grupoAtividade.value = [];
      grupoCadastrado.value = false;
    }
  } catch (error) {
    console.error("Erro ao carregar grupo:", error);
    if (error.response?.status === 404) {
      grupoAtividade.value = [];
      grupoCadastrado.value = false;
      grupoIdAtividade.value = null;
    }
  }
}

async function alterarFuncao(index) {
  if (alterandoIndex.value !== null) return;
  if (!grupoAtividade.value || !grupoAtividade.value[index]) return;
  const nomeMembro = grupoAtividade.value[index].nome;
  const membroGrupo = grupoAtividade.value[index];
  const dadosMembro = timeAcao.value.find((m) => m.nome === nomeMembro);
  if (!dadosMembro) return;

  alterandoIndex.value = index;
  try {
    if (verificarLidereanca(index)) {
      // Verificar se é coordenador antes de permitir rebaixamento
      if (verificarSeEhCoordenador(membroGrupo)) {
        await mostrarSucesso(
          `Não é possível alterar a função de <${nomeMembro}>.\nCoordenadores devem permanecer como líderes da equipe.`);
        return;
      }

      const confirmacao = await mostrarConfirmacao(
        `Tem certeza que deseja definir \n<${nomeMembro}> como participante?`
      );
      if (confirmacao) {
        await atividadeService.rebaixarMembroEquipe(
          props.atividadeId,
          dadosMembro
        );
        await carregarGrupo();
      }
    } else {
      const confirmacao = await mostrarConfirmacao(
        `Tem certeza de que deseja promover\n<${nomeMembro}> a líder?`
      );
      if (confirmacao) {
        await atividadeService.promoverMembroEquipe(
          props.atividadeId,
          dadosMembro
        );
        await carregarGrupo();
        await mostrarSucesso(
          `<${nomeMembro}> foi definido como\nlíder com sucesso!`
        );
      }
    }
  } catch (error) {
    console.error("Erro ao alterar função:", error);
  } finally {
    alterandoIndex.value = null;
  }
}

onMounted(async () => {
  document.body.classList.add("modal-aberto");

  try {
    await carregarGrupo();
    await getEquipeAcao();
    await carregarTituloAtividade();
  } catch (error) {
    console.error("Erro ao inicializar componente:", error);
  } finally {
    carregando.value = false;
  }
});

onBeforeUnmount(() => {
  document.body.classList.remove("modal-aberto");
});
</script>

<style scoped>
#cadastro {
  position: fixed;
  inset: 0;
  z-index: 1000;

  display: flex;
  align-items: center;
  justify-content: center;

  padding: 24px;

  background: rgba(18, 15, 28, 0.64);
  backdrop-filter: blur(3px);
}

.modal-equipe {
  display: flex;
  flex-direction: column;

  width: min(1120px, 100%);
  max-height: calc(100dvh - 48px);
  min-height: 0;

  overflow: hidden;

  background: var(--branco);
  border-radius: 18px;

  box-shadow: 0 24px 80px rgba(0, 0, 0, 0.24);

  animation: modal-entrada 0.2s ease-out;
}

@keyframes modal-entrada {
  from {
    opacity: 0;
    transform: translateY(10px) scale(0.99);
  }

  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

.modal-topo {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;

  flex-shrink: 0;

  padding: 22px 26px;

  color: var(--branco);
  background: var(--roxo-primario);
}

.modal-titulo {
  min-width: 0;
}

.modal-sobretitulo {
  display: block;
  margin-bottom: 5px;

  color: rgba(255, 255, 255, 0.78);

  font-size: 0.7rem;
  font-weight: 700;
  letter-spacing: 0.09em;
  text-transform: uppercase;
}

.modal-topo h4 {
  margin: 0;

  color: var(--branco);

  font-size: clamp(1.05rem, 2vw, 1.3rem);
  font-weight: 750;
  line-height: 1.3;
}

.titulo-atividade {
  margin: 6px 0 0;

  color: rgba(255, 255, 255, 0.88);

  font-size: 0.84rem;
  line-height: 1.5;

  overflow-wrap: anywhere;
}

.btn-fechar {
  display: grid;
  place-items: center;

  flex-shrink: 0;

  width: 40px;
  height: 40px;

  border: 1px solid rgba(255, 255, 255, 0.25);
  border-radius: 10px;

  color: var(--branco);
  background: rgba(255, 255, 255, 0.1);

  font-size: 1.15rem;
  cursor: pointer;

  transition: background 0.2s ease;
}

.btn-fechar:hover {
  background: rgba(255, 255, 255, 0.2);
}

.modal-conteudo {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 1px minmax(0, 1fr);

  flex: 1;
  min-height: 0;

  overflow: hidden;
}

.painel-equipe {
  display: flex;
  flex-direction: column;

  min-width: 0;
  min-height: 0;

  padding: 22px;
}

.divisor-vertical {
  align-self: stretch;
  background: var(--roxo-superficie);
}

.painel-cabecalho {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;

  flex-shrink: 0;

  margin-bottom: 16px;
}

.painel-cabecalho h5 {
  margin: 0 0 5px;

  color: var(--roxo-escuro);

  font-size: 1rem;
  font-weight: 750;
}

.painel-cabecalho p {
  margin: 0;

  color: var(--cinza-medio);

  font-size: 0.78rem;
  line-height: 1.5;
}

.contador {
  display: inline-flex;
  align-items: center;
  justify-content: center;

  min-width: 32px;
  height: 32px;
  padding: 0 9px;

  border-radius: 10px;

  color: var(--roxo-primario);
  background: var(--roxo-superficie);

  font-size: 0.8rem;
  font-weight: 800;
  font-variant-numeric: tabular-nums;
}

.contador-equipe {
  color: var(--branco);
  background: var(--roxo-primario);
}

.campo-busca {
  display: flex;
  align-items: center;
  gap: 10px;

  flex-shrink: 0;

  min-width: 0;
  min-height: 42px;
  padding: 0 13px;

  border: 1px solid var(--roxo-superficie);
  border-radius: 10px;

  color: var(--cinza-medio);
  background: var(--branco);

  transition: border-color 0.2s, box-shadow 0.2s;
}

.campo-busca:focus-within {
  border-color: var(--roxo-medio);
  box-shadow: 0 0 0 3px rgba(111, 49, 158, 0.1);
}

.campo-busca i {
  flex-shrink: 0;
  font-size: 0.85rem;
}

.campo-busca input {
  width: 100%;
  min-width: 0;
  padding: 10px 0;

  border: 0;
  outline: 0;

  color: var(--cinza-escuro);
  background: transparent;

  font: inherit;
  font-size: 0.8rem;
}

.campo-busca input::placeholder {
  color: var(--cinza-medio);
  opacity: 0.85;
}

.campo-busca input:focus-visible {
  outline: none;
}


.lista-membros {
  display: flex;
  flex-direction: column;
  gap: 8px;

  flex: 1;
  min-height: 0;
  min-width: 0;

  margin-top: 14px;
  padding: 2px 5px 2px 0;

  overflow-x: hidden;
  overflow-y: auto;

  overscroll-behavior: contain;
  scrollbar-gutter: stable;
}

.lista-membros::-webkit-scrollbar {
  width: 6px;
}

.lista-membros::-webkit-scrollbar-track {
  border-radius: 10px;
  background: var(--roxo-superficie);
}

.lista-membros::-webkit-scrollbar-thumb {
  border-radius: 10px;
  background: var(--roxo-claro, var(--roxo-medio));
}

.membro-livre,
.membro-alocado {
  display: flex;
  align-items: center;
  gap: 11px;

  min-width: 0;
  padding: 11px;

  border: 1px solid var(--roxo-superficie);
  border-radius: 11px;

  background: var(--branco);

  transition: border-color 0.18s, background 0.18s;
}

.membro-livre {
  cursor: pointer;
  user-select: none;
}

.membro-livre:hover {
  border-color: var(--roxo-claro, var(--roxo-medio));
  background: var(--roxo-superficie);
}

.membro-livre.membro-selecionado {
  border-color: var(--roxo-medio);
  background: var(--roxo-superficie);
}

.membro-livre input[type="checkbox"] {
  flex-shrink: 0;

  width: 17px;
  height: 17px;
  margin: 0;

  accent-color: var(--roxo-primario);
  cursor: pointer;
}

.avatar-membro {
  display: grid;
  place-items: center;

  flex-shrink: 0;

  width: 38px;
  height: 38px;

  border-radius: 11px;

  color: var(--roxo-primario);
  background: var(--roxo-superficie);

  font-size: 0.95rem;
  font-weight: 800;
  text-transform: uppercase;
}

.dados-membro {
  display: flex;
  flex-direction: column;
  gap: 4px;

  flex: 1;
  min-width: 0;
}

.dados-membro strong {
  color: var(--roxo-escuro);

  font-size: 0.8rem;
  font-weight: 700;
  line-height: 1.4;

  overflow-wrap: anywhere;
  word-break: break-word;
}

.dados-membro small {
  color: var(--cinza-medio);

  font-size: 0.72rem;
  line-height: 1.4;

  overflow-wrap: anywhere;
  word-break: break-word;
}

.icone-selecionado {
  flex-shrink: 0;
  color: var(--roxo-primario);
  font-size: 0.85rem;
}

.acoes-equipe {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 10px;

  flex-shrink: 0;

  margin-top: 12px;
}

.legenda-equipe {
  display: flex;
  align-items: center;
  gap: 6px;

  color: var(--cinza-medio);

  font-size: 0.69rem;
  line-height: 1.4;
}

.legenda-equipe i {
  color: var(--roxo-medio);
}

.btn-excluir-grupo {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 7px;

  padding: 7px 10px;

  border: 1px solid #f0c9cd;
  border-radius: 8px;

  color: #a52c38;
  background: #fff5f5;

  font-size: 0.72rem;
  font-weight: 700;

  cursor: pointer;
  transition: background 0.2s, border-color 0.2s;
}

.btn-excluir-grupo:hover {
  border-color: var(--vermelho);
  background: #fde8e8;
}

.lista-alocados {
  margin-top: 12px;
}

.membro-alocado {
  background: var(--roxo-superficie);
  border-color: transparent;
}

.papel-membro {
  display: inline-flex;
  align-items: center;
  gap: 5px;

  width: fit-content;

  color: var(--cinza-medio);
  font-size: 0.7rem;
  font-weight: 600;
}

.papel-membro.papel-lider {
  color: var(--roxo-medio);
  font-weight: 800;
}

.acoes-membro {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 9px;

  flex-shrink: 0;
}

.switch-track {
  position: relative;

  width: 38px;
  height: 22px;
  padding: 0;

  border: 0;
  border-radius: 999px;

  background: #d5d1dc;

  cursor: pointer;
  transition: background 0.2s;
}

.switch-track-ativo {
  background: var(--roxo-primario);
}

.switch-track:focus-visible,
.btn-remover:focus-visible,
.btn-excluir-grupo:focus-visible,
.btn-fechar:focus-visible,
.paginacao-lista button:focus-visible {
  outline: 3px solid var(--roxo-claro, var(--roxo-medio));
  outline-offset: 3px;
}

.switch-track:disabled {
  cursor: not-allowed;
  opacity: 0.5;
}

.switch-thumb {
  position: absolute;
  top: 3px;
  left: 3px;

  width: 16px;
  height: 16px;

  border-radius: 50%;
  background: var(--branco);

  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);

  transition: transform 0.2s ease;
}

.switch-track-ativo .switch-thumb {
  transform: translateX(16px);
}

.btn-remover {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 5px;

  padding: 6px 8px;

  border: 1px solid #f0c9cd;
  border-radius: 7px;

  color: #a52c38;
  background: var(--branco);

  font-size: 0.68rem;
  font-weight: 700;

  cursor: pointer;
  transition: background 0.2s, opacity 0.2s;
}

.btn-remover:hover:not(:disabled) {
  background: #fde8e8;
}

.btn-remover:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.paginacao-lista {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 16px;

  flex-shrink: 0;

  padding-top: 12px;
  margin-top: 10px;

  border-top: 1px solid var(--roxo-superficie);

  color: var(--cinza-escuro);

  font-size: 0.76rem;
  font-weight: 700;
  font-variant-numeric: tabular-nums;
}

.paginacao-lista button {
  display: grid;
  place-items: center;

  width: 32px;
  height: 32px;

  border: 1px solid var(--roxo-superficie);
  border-radius: 8px;

  color: var(--roxo-medio);
  background: var(--branco);

  cursor: pointer;
  transition: background 0.2s;
}

.paginacao-lista button:hover:not(:disabled) {
  background: var(--roxo-superficie);
}

.paginacao-lista button:disabled {
  opacity: 0.35;
  cursor: not-allowed;
}

.estado-lista {
  display: flex;
  flex: 1;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 12px;

  min-height: 120px;
  padding: 24px 12px;

  color: var(--cinza-medio);
  text-align: center;
}

.estado-lista>i {
  color: var(--roxo-claro, var(--roxo-medio));
  font-size: 1.6rem;
}

.estado-lista p,
.estado-lista span {
  margin: 0;

  font-size: 0.8rem;
  line-height: 1.6;

  overflow-wrap: anywhere;
}

.modal-rodape {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 18px;

  flex-shrink: 0;

  padding: 16px 24px;

  border-top: 1px solid var(--roxo-superficie);
  background: var(--branco);
}

.dica-rodape {
  display: flex;
  align-items: flex-start;
  gap: 8px;

  margin: 0;

  color: var(--cinza-medio);

  font-size: 0.72rem;
  line-height: 1.5;
}

.dica-rodape i {
  flex-shrink: 0;
  margin-top: 2px;
  color: var(--roxo-medio);
}

.botoes-rodape {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 10px;

  flex-shrink: 0;
}

#btn-cancelar,
#btn-salvar {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;

  min-height: 40px;
  padding: 9px 16px;

  border-radius: 10px;

  font-size: 0.78rem;
  font-weight: 700;

  cursor: pointer;
  transition: background 0.2s, border-color 0.2s, opacity 0.2s;
}

#btn-cancelar {
  border: 1px solid var(--roxo-superficie);

  color: var(--cinza-escuro);
  background: var(--branco);
}

#btn-cancelar:hover {
  border-color: var(--roxo-medio);
  background: var(--roxo-superficie);
}

#btn-salvar {
  border: 1px solid var(--roxo-primario);

  color: var(--branco);
  background: var(--roxo-primario);
}

#btn-salvar:hover:not(:disabled) {
  background: var(--roxo-medio);
}

#btn-salvar:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}

/* Modal de confirmação ou sucesso */

.aviso-overlay {
  position: fixed;
  inset: 0;
  z-index: 1100;

  display: flex;
  align-items: center;
  justify-content: center;

  padding: 20px;

  background: rgba(18, 15, 28, 0.65);
  backdrop-filter: blur(2px);
}

.aviso-box {
  width: min(420px, 100%);
  max-height: calc(100dvh - 40px);

  overflow-y: auto;

  border-radius: 15px;


  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.25);
}

.aviso-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;

  padding: 13px 18px;

  color: var(--branco);
  background: var(--roxo-primario);
}

.aviso-header span {
  font-size: 0.78rem;
  font-weight: 800;
  letter-spacing: 0.06em;
  text-transform: uppercase;
}

.aviso-fechar {
  display: grid;
  place-items: center;

  width: 32px;
  height: 32px;

  border: 0;
  border-radius: 8px;

  color: var(--branco);
  background: transparent;

  cursor: pointer;
}

.aviso-fechar:hover {
  background: rgba(255, 255, 255, 0.15);
}

.aviso-corpo {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 17px;
  background-color: var(--branco);

  padding: 1rem;
}

.aviso-icone {
  display: grid;
  place-items: center;

  flex-shrink: 0;

  width: 50px;
  height: 50px;

  border-radius: 50%;

  font-size: 1.5rem;
  font-weight: 800;
}

.aviso-icone.confirmacao {
  color: var(--branco);
  background: var(--roxo-medio);
}

.aviso-icone.sucesso {
  color: var(--branco);
  background: var(--verde);
}

.aviso-mensagem {
  width: 100%;
  margin: 0;

  color: var(--cinza-escuro);

  font-size: 0.88rem;
  line-height: 1.65;
  text-align: center;
  white-space: pre-line;
  overflow-wrap: anywhere;
}

.aviso-botoes {
  display: flex;
  flex-wrap: wrap;
  flex-direction: row-reverse;
  justify-content: center;
  gap: 10px;

  width: 100%;
}

.aviso-btn {
  min-height: 40px;
  padding: 9px 16px;

  border-radius: 9px;

  font-size: 0.8rem;
  font-weight: 700;

  cursor: pointer;
  transition: background 0.2s;
}

.aviso-btn-sim {
  border: 1px solid var(--roxo-primario);

  color: var(--branco);
  background: var(--roxo-primario);
}

.aviso-btn-sim:hover {
  background: var(--roxo-medio);
}

.aviso-btn-cancelar {

  color: var(--branco);
  background: var(--vermelho-escuro);
}

.aviso-btn-cancelar:hover {
  background: var(--vermelho);
}

.aviso-fade-enter-active,
.aviso-fade-leave-active {
  transition: opacity 0.2s ease;
}

.aviso-fade-enter-from,
.aviso-fade-leave-to {
  opacity: 0;
}

.aviso-fade-enter-active .aviso-box {
  transition: transform 0.2s ease;
}

.aviso-fade-enter-from .aviso-box {
  transform: scale(0.96);
}

/* Tablets */

@media (max-width: 900px) {
  #cadastro {
    padding: 14px;
  }

  .modal-equipe {
    max-height: calc(100dvh - 28px);
  }

  .painel-equipe {
    padding: 16px;
  }

  .modal-topo {
    padding: 18px 20px;
  }

  .modal-rodape {
    padding: 14px 18px;
  }

  .dica-rodape {
    max-width: 230px;
  }

  .membro-alocado,
  .membro-livre {
    gap: 8px;
    padding: 9px;
  }

  .avatar-membro {
    width: 32px;
    height: 32px;
    border-radius: 9px;
  }

  .acoes-membro {
    gap: 7px;
  }

  .btn-remover span {
    display: none;
  }

  .btn-remover {
    width: 34px;
    height: 30px;
    padding: 0;
  }
}

/* Celulares */

@media (max-width: 650px) {
  #cadastro {
    align-items: stretch;
    justify-content: stretch;

    padding: 0;
  }

  .modal-equipe {
    width: 100%;
    max-height: 100dvh;
    height: 100%;
    min-height: 0;

    border: 0;
    border-radius: 0;

    animation: modal-mobile-entrada 0.2s ease-out;
  }

  @keyframes modal-mobile-entrada {
    from {
      opacity: 0;
      transform: translateY(12px);
    }

    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  .modal-topo {
    gap: 12px;
    padding: 16px;
  }

  .modal-topo h4 {
    font-size: 1.05rem;
  }

  .btn-fechar {
    width: 38px;
    height: 38px;
  }

  .modal-conteudo {
    display: flex;
    flex-direction: column;
    gap: 0;

    flex: 1;
    min-height: 0;

    overflow-y: auto;
    overflow-x: hidden;

    overscroll-behavior: contain;
  }

  .painel-equipe {
    flex: 0 0 auto;

    min-height: 320px;
    height: min(48dvh, 430px);

    padding: 18px 16px;
  }

  .painel-disponiveis {
    border-bottom: 1px solid var(--roxo-superficie);
  }

  .divisor-vertical {
    display: none;
  }

  .painel-cabecalho {
    margin-bottom: 12px;
  }

  .lista-membros {
    min-height: 0;
  }

  .acoes-equipe {
    align-items: flex-start;
  }

  .modal-rodape {
    flex-direction: column;
    align-items: stretch;
    gap: 12px;

    padding: 12px 16px;

    padding-bottom: max(12px, env(safe-area-inset-bottom));
    box-shadow: 0 -5px 16px rgba(30, 20, 50, 0.04);
  }

  .dica-rodape {
    max-width: none;
  }

  .botoes-rodape {
    display: grid;
    grid-template-columns: minmax(0, 0.8fr) minmax(0, 1.2fr);
    width: 100%;
  }

  #btn-cancelar,
  #btn-salvar {
    width: 100%;
    min-width: 0;
    padding: 10px 8px;

    font-size: 0.75rem;
  }

  .aviso-overlay {
    padding: 16px;
  }

  .aviso-box {
    width: 100%;
    max-width: 400px;
  }
}

/* Celulares estreitos */

@media (max-width: 360px) {
  .painel-equipe {
    padding-right: 12px;
    padding-left: 12px;
  }

  .modal-topo {
    padding-right: 12px;
    padding-left: 12px;
  }

  .dados-membro strong {
    font-size: 0.75rem;
  }

  .dados-membro small {
    font-size: 0.67rem;
  }

  .legenda-equipe {
    font-size: 0.65rem;
  }

  .btn-excluir-grupo {
    padding: 6px 8px;
    font-size: 0.67rem;
  }

  .botoes-rodape {
    gap: 7px;
  }
}

@media (prefers-reduced-motion: reduce) {

  .modal-equipe,
  .aviso-fade-enter-active,
  .aviso-fade-leave-active,
  .aviso-fade-enter-active .aviso-box {
    animation: none;
    transition: none;
  }
}
</style>
